import React from 'react';
import { Box, H5, Icon } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from '../VehicleListFilters.styles';
const HeaderWrapper = themeStyles.apply(Box, 'HeaderWrapper');
const CloseButton = themeStyles.apply('button', 'CloseButton');
const CloseIcon = themeStyles.apply(Icon, 'CloseIcon');
const FiltersListMobileHeader = ({ setMobileFiltersOpen, isMobileFiltersOpen }) => {
    const { t } = useTranslation();
    return (React.createElement(HeaderWrapper, null,
        React.createElement(H5, { "data-testid": "cy-filters-header" }, t('Pages.Models.Exploration.filterHeading')),
        React.createElement(CloseButton, { type: "button", onClick: () => setMobileFiltersOpen((prevState) => !prevState) },
            React.createElement(CloseIcon, { name: isMobileFiltersOpen ? 'close' : 'plus' }))));
};
export default FiltersListMobileHeader;
